import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import classNames from 'classnames'
import { isValidators, isRequired } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SearchSubProject from '../../components/forms/searchSubProject/SearchSubProject'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadDetails } from '../../redux/actions/subProjectReport'

export default function SubProjectReportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isSucceed, setIsSucceed] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})

  useEffect(() => {
    console.log('load ProjectName projectId')
  }, [])

  const onSubmit = (data) => {
    console.log('data aaaaa', data)

    const request = {
      projectCode: data.projectCode,
      budgetYear: parseInt(data.constYear),
      constYear: parseInt(data.constYear),
      departmentId: parseInt(data.projectDepartment),
      projectStatus: parseInt(data.projectStatus),
      reportType: parseInt(data.projectReportType),
      columns: data.columns,
    }
    handleCallReportSubmitPdf(request)
  }

  const handleCheangMainProject = (data) => {
    console.log('handleCheangMainProject=> ', data)

    const disValue = {
      buttonText: formSchema.buttonText.disabled,
      subProjectOption: false,
      mainProjectOption: formSchema.searchObject.mainProjectOption.disabled,
    }
    setDisableValue(disValue)
  }

  const handleCancel = () => {
    console.log('handleCancel')
    // location.reload()
    for (const key in getValues()) {
      setValue(key, null)
    }
  }

  const handleCallReportSubmitPdf = async (data) => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)

    try {
      const response = await downloadDetails(data)
      console.log('gggg ', response)
      if (response) {
        onDownload(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.error(e)
      setIsPdfError(true)
    }

    setIsLoadingPDF(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    if (fileObj) {
      const url = window.URL.createObjectURL(fileObj)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.fileName || `รายงานโครงการย่อย`)
      document.body.appendChild(link)
      link.click()
    }
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <SearchSubProject
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onChangeMainProject={handleCheangMainProject}
            disabledValue={disabledValue}
          />
        )}

        <hr />
        {isPdfError && (
          <>
            <Message showIcon type="error" description={'ไม่สามารถโหลดไฟล์ได้'} />
            <br />
          </>
        )}

        <ButtonPanelWidget
          isDisabled={disabledValue.buttonText}
          isEdit={isEdit}
          isError={isError}
          buttonText={{
            disabled: false,
            errorMessage: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
            downloadButtonName: 'ดาวน์โหลด',
            previewButtonName: null,
            cancelButtonName: 'ยกเลิก',
          }}
          onPrint={handleSubmit(onSubmit)}
          onCancel={(el) => {
            setIsError(false)
            handleCancel()
          }}
        />
      </Panel>

      <br />
    </>
  )
}
